<mat-toolbar class="toolbar toolbar-large mat-elevation-z1" color="primary">
  @if (routerUrl.indexOf('/deals') >= 0 || routerUrl.indexOf('/vinyl') >= 0) {
    <button
      mat-icon-button
      class="menu-button"
      (click)="sidenavService.toggle()"
      >
      <mat-icon>menu</mat-icon>
    </button>
  }
  <button class="title-container" mat-button routerLink="/deals">
    <div class="title-top">
      <mat-icon class="logo">eco</mat-icon>
      <span>Deal</span>
    </div>
    <div class="title-bottom">Forager</div>
  </button>
<span class="example-spacer"></span>
<div class="example-button-row">
  <button
    mat-button
    routerLink="/deals"
    routerLinkActive="active"
    class="link-button multiline-button"
    >
    <div class="link-title-container show-small">
      <div class="title-top hide-phone-small">Warehouse</div>
      <div class="title-top show-phone-small">Used</div>
      <div class="title-bottom">Deals</div>
    </div>
    <div class="link-title-container hide-small">
      <div>Warehouse Deals</div>
    </div>
  </button>
  <button
    mat-button
    routerLink="/livefeed"
    routerLinkActive="active"
    class="link-button"
    >
    Live
  </button>
  <button
    mat-button
    routerLink="/about"
    routerLinkActive="active"
    class="link-button hide-very-small"
    >
    About
  </button>
  <mat-form-field class="domain-container" appearance="fill">
    <mat-select class="domain-select" [formControl]="selectedDomain" panelClass="domain-panel">
      <mat-select-trigger>{{ domainAcronyms[selectedDomain.value] }}</mat-select-trigger>
      @for (domain of domains | keyvalue:domainOrder; track domain) {
        <mat-option
          [value]="domain.key"
          >{{ domain.value }}</mat-option
          >
        }
      </mat-select>
    </mat-form-field>
  </div>
</mat-toolbar>
